<template>
  <div class="wrap">
    <router-view></router-view>

    <Dialog
      :cancelText="dialogConfig.cancelText"
      :close="openDialog"
      :confirmText="dialogConfig.confirmText"
      :dialogContent="dialogConfig.dialogContent"
      :hideClose="dialogConfig.hideClose"
      :isShown="dialogConfig.isShown"
      :onCancel="dialogConfig.onCancel"
      :onConfirm="dialogConfig.onConfirm"
      :targetClassName="dialogConfig.targetClassName"
    ></Dialog>

    <ShareImgDialog @closeShareDialog="closeShareDialog" v-if="showShareDialog"></ShareImgDialog>

    <Toast :toastMsg="toastMsg"></Toast>
    <Loading :isLoading="isLoading" :loadingMsg="loadingMsg"></Loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex"
import "../../../ui/LianPoH5/css/main.css"
import Dialog from "./component/Dialog.vue"
import ShareImgDialog from "./component/ShareImgDialog.vue"
import Toast from "./component/Toast.vue"
import Loading from "./component/Loading.vue"
import * as urlUtil from "../common/utils/url.js"

let configs = window.__midasStaticConfig_wzry_tuan_config

export default {
  name: "App",
  data() {
    return {
      isWechatShareTipsShown: false
    }
  },
  created() {
    // 特殊逻辑：微信分享到QQ的链接，在QQ内重新分享不可改变分享内容(分享出去还是原链接)，重新reload之后才可以
    if (this.pf == "__mds_wxtuan_share" && this.userAgent.QQ) {
      location.href = urlUtil.addGetParam({ pf: "__mds_wxtuanshare" }, location.href)
    }
    // 检测横竖屏并提示
    this.checkOrientation()
    window.addEventListener("resize", () => {
      this.checkOrientation()
    })
    if (!this.userAgent.msdk && !this.userAgent.QQ && !this.userAgent.weixin) {
      // 认为是在浏览器内，不支持参与活动
      this.openDialog({
        dialogContent: "<p class='text'>暂不支持在当前环境参与活动</p><p class='text'>请在QQ或微信客户端中参与活动哦~</p>",
        confirmText: "去微信",
        cancelText: "去QQ",
        hideClose: true,
        onConfirm: () => {
          this.goToActivityPage("wechat")
        },
        onCancel: () => {
          this.goToActivityPage("qq")
        }
      })
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.PAGE_BROWSER_ERROR
      })
    }
    if (this.gameInfoConfigs && this.gameInfoConfigs.tuanConfig && this.gameInfoConfigs.tuanConfig.activityEndTime) {
      if (new Date().getTime() >= new Date(this.gameInfoConfigs.tuanConfig.activityEndTime.replace(/-/g, "/"))) {
        this.openDialog({
          dialogContent: "<div class='subscribe_to_img'></div><p class='text'>活动已结束，下期更精彩哦~</p>",
          confirmText: "去游戏专区逛逛",
          onConfirm: () => {
            this.goToStorePage()
          },
          targetClassName: "alert_currency",
          hideClose: true
        })
      }
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.PAGE_OUTDATE_ERROR
      })
    }
  },
  components: { Dialog, ShareImgDialog, Toast, Loading },
  computed: {
    ...mapState(["toastMsg", "isLoading", "loadingMsg", "showShareDialog", "dialogConfig"]),
    ...mapGetters(["gameInfoConfigs", "userAgent", "pf"])
  },
  methods: {
    ...mapActions(["reportUserAction", "openDialog", "setShareDialogStatus", "goToStorePage", "setToastMsg", "goToActivityPage"]),

    closeShareDialog() {
      this.setShareDialogStatus(false)
    },

    // 检测横竖屏并提示
    checkOrientation() {
      let mql = window.matchMedia && window.matchMedia("(orientation: portrait)")
      if (mql) {
        if (mql.matches) {
          // 竖屏
        } else {
          // 横屏
          this.setToastMsg("竖屏体验更佳哦")
        }
      }
    }
  }
}
</script>
